import { Scene, Scenario } from '../types';
import { filterChaptersForMission } from './mission-progress';
import { getChapterSceneIds } from './scene-flow';

export function getChapterLabelForScene(
  scenario: Pick<Scenario, 'metadata' | 'scenes'>,
  sceneId: string,
  missionId?: string
): string | undefined {
  const chapters = filterChaptersForMission(scenario.metadata.chapters, missionId);
  if (!chapters.length) return undefined;

  const sceneIndexById = new Map(scenario.scenes.map((scene, index) => [scene.id, index]));
  const sorted = [...chapters].sort((a, b) => {
    const indexA = sceneIndexById.get(a.startScene) ?? Number.MAX_SAFE_INTEGER;
    const indexB = sceneIndexById.get(b.startScene) ?? Number.MAX_SAFE_INTEGER;
    return indexA - indexB;
  });

  for (let index = 0; index < sorted.length; index++) {
    const chapter = sorted[index]!;
    const sceneIds = getChapterSceneIds(scenario as Scenario, chapter.startScene);
    if (sceneIds.includes(sceneId)) {
      return `Chapitre ${index + 1}`;
    }
  }

  return undefined;
}

export function getSceneExcerptWithSpeaker(scene: Scene | null): string | undefined {
  if (!scene || scene.type !== 'dialogue' || !scene.text?.trim()) {
    return undefined;
  }

  const text = scene.text.trim();
  const clipped = text.length > 120 ? `${text.slice(0, 120)}…` : text;
  if (scene.speaker?.trim()) {
    return `${scene.speaker.trim()} : "${clipped}"`;
  }
  return `"${clipped}"`;
}
